export const dashboardPersonalTaskTour = {
  key: "dashboardPersonalTask",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="dash-personal-categories"]',
      content: t("Tour_Dashboard_PersonalCategories"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="dash-personal-addtask"]',
      content: t("Tour_Dashboard_PersonalAddTask"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dash-personal-views"]',
      content: t("Tour_Dashboard_PersonalViews"),
      placement: "top",
    },
  ],
};
